<template>
    <div class="bid-price-info">
        <el-table :data="tableData" stripe border v-loading="loading" max-height="380" style="width: 100%">
            <el-table-column prop="opportunityName" label="项目名称"></el-table-column>
            <el-table-column prop="industryTypeCn" label="业务类型"></el-table-column>
            <el-table-column prop="cdBidScale" label="中标规模"></el-table-column>
            <el-table-column prop="_isControlWarehouse" label="是否控仓控货"></el-table-column>
            <el-table-column prop="_projectType" label="项目类型"></el-table-column>
            <el-table-column prop="_isStreamRelation" label="上下游关联关系"></el-table-column>
        </el-table>
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :offset="12" :span="12">
                <m-page
                    ref="page"
                    :current-page="currentPage"
                    :pageData="pageConfig"
                    :total="pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"></m-page>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mPage from '@/components/supplierPanel/mPage'
import { searchOpportunityInfos } from '../../../api/tenderOffer/tenderCostDetails.js'
import { dictWithUrl } from '@/components/lots/api'
import { codesToNames } from '../../costManage/utils/costCommon.js';
export default {
    components: { mPage },
    data() {
        return {
            loading: false,
            tableData: [],
            pageTotal: 0,
            pageNo: 1,
            pageSize: 10,
            totalCount: 0,
            currentPage: 1,
            dictData: {},
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10,
            },
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            // 数字字典转换
            //  是否控仓- BILLING_EXPRESS_CONTROL
            //  项目类型- PROJECT_TYPE
            dictWithUrl('BILLING_EXPRESS_CONTROL,PROJECT_TYPE,SRM_STREAM_RELATION,SYS_BMS_BUSI_TYPE').then(res => {
                this.dictData = res.data
                this.loadData()
            })
        },
        conversionData(list) {
            for (const item of list) {
                item._isControlWarehouse = this.dictData.BILLING_EXPRESS_CONTROL[item.isControlWarehouse];//是否控仓- BILLING_EXPRESS_CONTROL
                item._projectType = this.dictData.PROJECT_TYPE[item.projectType];//项目类型- PROJECT_TYPE
                item._isStreamRelation = this.dictData.SRM_STREAM_RELATION[item.isStreamRelation];// 上下游关联关系- SRM_STREAM_RELATION
                item.industryTypeCn = codesToNames(this.formatParse(item.industryType),this.dictData.SYS_BMS_BUSI_TYPE) || ''; // 业务类别 - SYS_BMS_BUSI_TYPE           
            }
            return list;
        },
        formatParse(data){
            try {
                const _data = JSON.parse(data)
                if(Array.isArray(_data) && _data.length){
                    return _data.join(',')
                }
                return ''
            } catch (error) {
                return ''
            }
        },
        pageChange(pageNo) {
            this.pageNo = pageNo
            this.getData()
        },
        sizeChange(size) {
            this.pageSize = size
            this.getData()
        },
        loadData() {
            let params = {
                projectCode:this.$route.query.projectCode,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            }
            this.loading = true
            searchOpportunityInfos(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { list, totalCount } = res.data
                        this.pageTotal = totalCount
                        if (Array.isArray(list)) {
                            this.tableData = this.conversionData(list)
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
<style lang="less" scoped>
.row-bg {
    margin-top: 10px;
}
.bid-price-info {
    margin: 0 20px 15px;
}
</style>
